import { Heading } from '@sparemin/blockhead';

const NoResults: React.FC = () => <Heading level={2}>No results</Heading>;

export default NoResults;
